import {
  IItems,
  InsightsApi,
  IpexMomentEnum,
  DesignInteractionEnum,
  DesignSourceEnum
} from '@insights/insights-data-provider';
import AnalyticsApi from '../AnalyticsApi';
import AnalyticsEvent, { AnalyticsPayload } from '../AnalyticsEvent';
import EventReporter from '../EventReporter';
import { ReportSourceEnum } from 'analytics/reporters';

const { giveMe, showMe, nonInteraction } = IpexMomentEnum;

class InsightsEventSpec<TPayload extends AnalyticsPayload> {
  constructor(
    private readonly eventName: string,
    private readonly ipexMoment: IpexMomentEnum,
    private readonly send: (insightsApi: InsightsApi, payload: TPayload) => void
  ) {}

  reporter(analytics: AnalyticsApi): EventReporter<TPayload> {
    return analytics.reporter<TPayload>(this.eventName, this.ipexMoment);
  }

  sendToInsights(insightsApi: InsightsApi, event: AnalyticsEvent): boolean {
    if (!this.isA(event)) {
      return false;
    }
    this.send(insightsApi, event.payload);
    return true;
  }

  private isA(event: AnalyticsEvent): event is AnalyticsEvent<TPayload> {
    return event.eventName === this.eventName;
  }
}

export default Object.freeze({
  addToCart: new InsightsEventSpec<IItems>('add_to_cart', giveMe, (insightsApi, payload) =>
    insightsApi.addToCart({
      items: payload.items,
      currency: payload.currency,
      designId: payload.designId
    })
  ),
  addToWishlist: new InsightsEventSpec<IItems>('add_to_wishlist', giveMe, (insightsApi, payload) =>
    insightsApi.addToWishList({
      items: payload.items,
      currency: payload.currency,
      designId: payload.designId
    })
  ),
  initPlanningSession: new InsightsEventSpec<{
    vpcCode: string;
    source: DesignSourceEnum;
    payload?: object;
    spr?: string;
  }>('init_planning_session', nonInteraction, (insightsApi, payload) =>
    insightsApi.initPlanningSession(payload.vpcCode, payload.source, payload.payload, payload.spr)
  ),
  saveDesign: new InsightsEventSpec<{
    vpcCode: string;
    designId?: string;
    page?: ReportSourceEnum;
  }>('save_design', giveMe, (insightsApi, payload) =>
    insightsApi.saveDesign(payload.vpcCode, {
      profile_design_id: payload.designId,
      page: payload.page
    })
  ),
  vpcInteraction: new InsightsEventSpec<{
    vpcCode: string;
    interaction: DesignInteractionEnum;
  }>('vpc_interaction', showMe, (insightsApi, payload) =>
    insightsApi.sendDesignInteractionEvent(payload.vpcCode, payload.interaction)
  )
});
